<div class="w-full flex gap-2 desktop:flex-wrap mobile:flex-col">
    <div class="desktop:flex-[1] min-w-[300px] min-h-[500px] mobile:h-[500px]">
        <iframe *ngIf="safePdfUrl" [src]="safePdfUrl" width="100%" height="100%" frameborder="0" style="border: none;">
        </iframe>

        <!--            <ngx-extended-pdf-viewer [src]="pdfData" [height]="'100%'" [textLayer]="true" [handTool]="false " [showHandToolButton]="true">-->
        <!--            </ngx-extended-pdf-viewer>-->
    </div>
    <div class="desktop:flex-[1] min-w-[300px] min-h-[500px] mobile:h-auto flex flex-col gap-2">
        <p class="font-bold text-xl py-5">{{ 'admin.ai_analysis' | transloco }}</p>

        <div class="w-full">
            <app-company-information [invoice]="invoice" [toast]="toast" [commodityType]="CommodityType.electricity"
                [successCallbackFunction]="hardReloadCallbackFunction"
                [listOfLocations]="listOfLocations"></app-company-information>
        </div>
        <!-- Edit invoice -->
        <div class="w-full">
            <app-edit-electricity-invoice #editElectricity [toast]="toast" [reloadCallbackFunction]="reloadCallbackFunction"
                [invoice]="baseInvoice" [listOfLocations]="listOfLocations"></app-edit-electricity-invoice>
        </div>
    </div>
</div>